import React from 'react';
import { createRoot } from 'react-dom/client';

function Topbar({ brand = {}, navItems = [], user = null }) {
  const brandLabel = brand.label || 'EduFun';

  return (
    <header className="topbar">
      <a className="brand" href={brand.href || '/'} aria-label={`${brandLabel} dashboard`}>
        <span
          className={`brand-mark${brand.logoUrl ? ' brand-logo-mark' : ''}`}
          data-egg-trigger
          data-egg-unlock-url={brand.eggUnlockUrl || ''}
        >
          {brand.logoUrl ? (
            <img className="brand-logo-full" src={brand.logoUrl} alt="" />
          ) : brand.logoIconUrl ? (
            <img className="brand-logo-icon" src={brand.logoIconUrl} alt="" />
          ) : (
            brand.mark || 'EF'
          )}
        </span>
        {! brand.logoUrl ? <span>{brandLabel}</span> : null}
      </a>

      {user ? (
        <>
          <nav className="nav-links" aria-label="Primary">
            {navItems.map((item) => (
              <a
                key={item.href}
                className={item.active ? 'active' : ''}
                href={item.href}
                aria-current={item.active ? 'page' : undefined}
              >
                {item.tag ? <span className="nav-token" aria-hidden="true">{item.tag}</span> : null}
                <span>{item.label}</span>
              </a>
            ))}
          </nav>
          <div className="user-actions">
            <a
              className={`user-pill${user.accountActive ? ' active' : ''}`}
              href={user.accountHref}
              aria-label="Account settings"
              aria-current={user.accountActive ? 'page' : undefined}
            >
              {user.avatarImageUrl ? (
                <img className="user-avatar" src={user.avatarImageUrl} alt="" />
              ) : (
                <span className="user-avatar user-avatar-initial">{user.initial || 'E'}</span>
              )}
              <span>{user.name}</span>
            </a>
            <form action={user.logoutAction} method="post">
              {user.csrfToken ? <input type="hidden" name="_token" value={user.csrfToken} /> : null}
              <button className="button ghost" type="submit">Bye!</button>
            </form>
          </div>
        </>
      ) : null}
    </header>
  );
}

function SubjectsPage({ subjects = [] }) {
  return (
    <section className="subject-grid full">
      {subjects.map((subject) => (
        <article className={`subject-card accent-${subject.accent}`} key={subject.key}>
          <div className="subject-card-header">
            <span className="subject-status">{subject.statusLabel}</span>
            <strong>{subject.short}</strong>
          </div>
          <h2>{subject.name}</h2>
          <p>{subject.description}</p>
          <small>
            {subject.topicCount} topics - {subject.standardsLabel} - {subject.difficultyLevels} difficulty levels
          </small>
          <div className="subject-metrics">
            <span className={`subject-rating rating-${subject.stats.ratingClass}`}>
              {subject.stats.rating}
            </span>
            <strong>{subject.stats.accuracy}%</strong>
          </div>
          <div className="meter">
            <span style={{ width: `${subject.stats.accuracy}%` }} />
          </div>
          <small>{subject.stats.correct} / {subject.stats.attempts} correct</small>
          {subject.active ? (
            <a className="button primary wide" href={subject.startUrl}>Start answering</a>
          ) : null}
        </article>
      ))}
    </section>
  );
}

const components = {
  Topbar,
  SubjectsPage,
};

function readProps(element) {
  try {
    return JSON.parse(element.dataset.props || '{}');
  } catch (error) {
    console.error('Invalid React component props', error);
    return {};
  }
}

document.querySelectorAll('[data-react-component]').forEach((element) => {
  const Component = components[element.dataset.reactComponent];

  if (! Component) {
    return;
  }

  createRoot(element).render(<Component {...readProps(element)} />);
});
